var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "add-item-quantity-wrapper" }, [
    _c("div", { staticClass: "add-item-quantity-label" }, [_vm._v("Quantity")]),
    _vm._v(" "),
    _c("div", { staticClass: "add-item-quantity" }, [
      _c(
        "button",
        {
          staticClass: "item-quantity-button",
          attrs: {
            "aria-label": `Decrease Quantity for ${_vm.itemName} from ${
              _vm.quantity
            } to ${_vm.quantity - 1}`,
            type: "button",
          },
          on: {
            click: function ($event) {
              return _vm.handleQuantityDecrease()
            },
          },
        },
        [_vm._v("\n\t\t\t-\n\t\t")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "item-quantity",
          attrs: { tabindex: "0", "aria-label": `Quantity ${_vm.quantity}` },
        },
        [_vm._v(_vm._s(_vm.quantity))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "item-quantity-button",
          attrs: {
            "aria-label": `Increase Quantity for ${_vm.itemName} from ${
              _vm.quantity
            } to ${_vm.quantity + 1}`,
            type: "button",
          },
          on: {
            click: function ($event) {
              return _vm.handleQuantityIncrease()
            },
          },
        },
        [_vm._v("\n\t\t\t+\n\t\t")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }